export enum IDBDatabases {
    LANCETECH_DB = 'LANCETECH_DB',
  }
  
  /**
   * Enum for each store name in indexedDB
   */
  export enum IDBStores {
    MISC_IMAGES = 'miscImages'
  }
  
  export const IDBStoresArray = Object.values(IDBStores);
  